import React, { useEffect, useState } from 'react'
import { Badge, Card, Col, Container, Modal, Row, Table } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'
import { getSchoolBySelection } from '../../actions/schoolsActions'
import { getSelection } from '../../actions/selectionsActions'
import SubMenuSelection from '../../components/menus/SubMenuSelection'
import { getChoosesBySelection, getInterviewsCalendarBySchool } from '../../actions/choosesActions'
import '@fullcalendar/bootstrap5/main.css'
import '@fullcalendar/daygrid/main.css'
import { getCourseSubjects, getLevels } from '../../actions/miscellaneousActions'
import CandidateProfile from '../admin/CandidateProfile'

export default function RefusedsSelection() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const params = useParams()
    const dispatch = useDispatch()

    const {school} = useSelector(state=>state.schools)
    const {selection, candidatesLoading} = useSelector(state=>state.selections)
    const {chooses} = useSelector(state => state.chooses)

    const [selectedCandidateProfile, setSelectedCandidateProfile] = useState(null)

    useEffect(() => {
        if(client){
            dispatch(getSchoolBySelection(params.id))
            dispatch(getLevels())
            dispatch(getCourseSubjects())
        }
    },[dispatch, t, client, params.id])

    useEffect(() => {
        if(school){
            dispatch(getChoosesBySelection(params.id))
            dispatch(getSelection(params.id))
            dispatch(getInterviewsCalendarBySchool(school._id))
        }
    },[school, dispatch, params.id])

    return (
        <>
            <Container className='cuerpo'>
                <Row className="mb-5">
                    <Col className='d-flex align-items-center'>
                        <img src="/images/config.svg" alt="Icono Configuración" />
                        <h1 className='ms-2 m-0'>{t('menus.activeSelection')}</h1>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra lateral'>
                            <Card.Body className='p-5'>
                                <SubMenuSelection selection={selection} section="refuseds"/>
                                <Row className='my-3'>
                                    <Col className='my-3'>
                                        {chooses?.filter(c => c.candidateStatus === 2 || c.candidateOfferLetterStatus === 2)?.length > 0
                                        ?
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>{t('school.selection.name')}</th>
                                                    <th className='text-center'>{t('school.selection.affinity')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    chooses?.filter(c => c.candidateStatus === 2 || c.candidateOfferLetterStatus === 2)?.map((candidate, index) => (
                                                        <tr key={index}>
                                                            <td className='d-flex align-items-center'>
                                                                <div className='avatar-mini list cursor me-2' onClick={() => setSelectedCandidateProfile(candidate.user._id)}>
                                                                    <div className='img-profile' style={{backgroundImage: `url(${candidate.user?.image ? candidate.user.image : "/images/avatar-empty.svg"})`}}/>
                                                                </div>
                                                                { candidate.candidate.firstname } { candidate.candidate.lastname }
                                                            </td>
                                                            <td className='align-middle text-center'><Badge className='bg-grey'>{candidate.porcentage}%</Badge></td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                        :
                                        <div className='text-center'>{t('school.selection.nocandidates')}</div>
                                        }
                                    </Col>
                                    {
                                        candidatesLoading &&
                                        <div className='text-center'>
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </div>
                                    }
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Modal show={selectedCandidateProfile ? true : false} dialogClassName="modal-90w" aria-labelledby="example-custom-modal-styling-title" centered>
                    <Modal.Header>
                        <Modal.Title id="example-custom-modal-styling-title" className='w-100 d-flex justify-content-end'>
                            <div>
                                <i className='fa fa-times cursor' onClick={() => setSelectedCandidateProfile(null)}></i>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <CandidateProfile candidateToShow={{iduser: selectedCandidateProfile}}/>
                    </Modal.Body>
                </Modal>
            </Container>
        </>
    )
}